import React from 'react';
import { Link } from 'react-router-dom';
import backgroundImage from '../assets/background.jpg'; // Adjust the path based on your folder structure
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesome
import { faLaptopCode, faDesktop, faMobileAlt, faCogs, faCloud, faBullhorn } from '@fortawesome/free-solid-svg-icons'; // Import the necessary icons
import { motion } from "framer-motion";

const Services = () => {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="flex flex-col items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          height: '50vh',
        }}
      >
        <div className="flex flex-col items-center justify-center text-center py-10">
          <h6 className="text-xl font-normal text-white">Gravionix technologies</h6>
          <h1 className="text-5xl font-bold text-white">Our services</h1>
        </div>

        <div className="mt-8">
          <nav className="flex space-x-6">
            <Link to="/" className="text-lg text-blue-500 hover:text-blue-700">
              Home
            </Link>
            <span className="text-lg text-blue-500">/</span> {/* Dash between links */}
            <Link to="/services" className="text-lg text-blue-500 hover:text-blue-700">
              Services
            </Link>
          </nav>
        </div>
      </div>


      {/* Our Services Section */}
      <section className="py-16 bg-white">
              <div className="container mx-auto px-6">
                <h6 className="text-xl font-normal mb-4 text-blue-800 text-center">Our Services</h6>
                <h2 className="text-3xl font-bold mb-8 text-center">Transforming Your Business with Our Expert Services</h2>
                <p className="text-base text-gray-700 mb-12 text-center">
                  At Gravionix technologies, we offer a range of services designed to drive your business forward. Our team of experts is
                  ready to assist with technology solutions tailored to your needs, ensuring your success in a digital-first world.
                </p>
      
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12">
                  {['Software Development', 'Web Development', 'App Development', 'Blockchain Development', 'Digital Marketing', 'SEO'].map((service, index) => (
                    <motion.div
                      className="p-6 bg-blue-100 rounded-lg shadow-lg hover:shadow-2xl transition-transform transform hover:scale-105 hover:translate-y-[-10px] flex flex-col items-center justify-center"
                      whileInView={{ opacity: 1, y: 0 }}
                      initial={{ opacity: 0, y: 50 }}
                      transition={{ duration: 1, delay: index * 0.2 }}
                      viewport={{ once: false }}
                      key={index}
                    >
                      <FontAwesomeIcon
                        icon={[faLaptopCode, faDesktop, faMobileAlt, faCogs, faCloud, faBullhorn][index]}
                        className="text-3xl sm:text-4xl text-blue-800 mb-4 mx-auto"
                      />
                      <h4 className="text-xl sm:text-2xl font-semibold mb-4 text-center">{service}</h4>
                      <p className="text-sm text-gray-600 text-center">
                        This is a description for the {service}. We help you achieve success with tailored solutions.
                      </p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </section>


            <section className="py-16 bg-gray-100">
    <div className="container mx-auto px-6">
        <h6 className="text-xl font-normal mb-4 text-blue-800 text-center">Our Service Features</h6>
        <h2 className="text-3xl font-bold mb-8 text-center">Key Features of Our Services</h2>
        <p className="text-base text-gray-700 mb-12 text-center">
            We focus on delivering top-quality services that meet the highest standards. Here are some of the key features that make our solutions unique and valuable for your business.
        </p>

        <div className="space-y-8">
            {/* Service 1 */}
            <div className="flex flex-row items-center space-x-6 border-2 border-blue-300 p-6 rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 bg-blue-50">
                <FontAwesomeIcon icon={faCogs} className="text-3xl sm:text-4xl p-2 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 text-white" />
                <div>
                    <h3 className="text-lg sm:text-2xl font-semibold text-blue-800 mb-2">High-Quality Development</h3>
                    <p className="text-sm sm:text-base text-gray-600">
                        Our experienced team of developers creates scalable, efficient, and innovative solutions to ensure your business stays ahead of the curve. We work closely with you to bring your vision to life.
                    </p>
                </div>
            </div>

           

            {/* Service 3 */}
            <div className="flex flex-row items-center space-x-6 border-2 border-blue-300 p-6 rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 bg-blue-50">
                <FontAwesomeIcon icon={faDesktop} className="text-3xl sm:text-4xl p-2 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 text-white" />
                <div>
                    <h3 className="text-lg sm:text-2xl font-semibold text-blue-800 mb-2">Custom Web Development</h3>
                    <p className="text-sm sm:text-base text-gray-600">
                        We specialize in designing and developing custom websites that are not only visually appealing but also user-friendly. Our websites are designed to enhance user experience and business growth.
                    </p>
                </div>
            </div>

            {/* Service 4 */}
            <div className="flex flex-row items-center space-x-6 border-2 border-blue-300 p-6 rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 bg-blue-50">
                <FontAwesomeIcon icon={faMobileAlt} className="text-3xl sm:text-4xl p-2 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 text-white" />
                <div>
                    <h3 className="text-lg sm:text-2xl font-semibold text-blue-800 mb-2">Mobile Application Development</h3>
                    <p className="text-sm sm:text-base text-gray-600">
                        Whether for Android or iOS, our mobile apps provide top-notch performance and functionality. We create apps that deliver exceptional user experiences and ensure business success.
                    </p>
                </div>
            </div>

            {/* Service 5 */}
            <div className="flex flex-row items-center space-x-6 border-2 border-blue-300 p-6 rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 bg-blue-50">
                <FontAwesomeIcon icon={faLaptopCode} className="text-3xl sm:text-4xl p-2 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 text-white" />
                <div>
                    <h3 className="text-lg sm:text-2xl font-semibold text-blue-800 mb-2">Industry Expertise</h3>
                    <p className="text-sm sm:text-base text-gray-600">
                        Our team brings expertise from various industries to provide solutions that are not only effective but also industry-relevant. We continuously adapt our services to align with current trends and needs.
                    </p>
                </div>
            </div>

            {/* Service 6 */}
            <div className="flex flex-row items-center space-x-6 border-2 border-blue-300 p-6 rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 bg-blue-50">
                <FontAwesomeIcon icon={faBullhorn} className="text-3xl sm:text-4xl p-2 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 text-white" />
                <div>
                    <h3 className="text-lg sm:text-2xl font-semibold text-blue-800 mb-2">Comprehensive Digital Marketing</h3>
                    <p className="text-sm sm:text-base text-gray-600">
                        We offer end-to-end digital marketing services, including SEO, PPC, social media marketing, and content strategy, designed to improve your online presence and drive business growth.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>


    </div>
  );
};

export default Services;
